import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, unref as _unref, withKeys as _withKeys, createVNode as _createVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, withModifiers as _withModifiers, createCommentVNode as _createCommentVNode } from "vue"

const _hoisted_1 = { class: "section-card" }
const _hoisted_2 = { class: "toolbar" }
const _hoisted_3 = { class: "toolbar-left" }
const _hoisted_4 = { class: "count-badge" }
const _hoisted_5 = { class: "toolbar-right" }
const _hoisted_6 = { class: "sort-group" }
const _hoisted_7 = { class: "user-list" }
const _hoisted_8 = { class: "card-row row-top" }
const _hoisted_9 = ["onClick"]
const _hoisted_10 = {
  key: 0,
  class: "user-nickname"
}
const _hoisted_11 = {
  key: 0,
  class: "card-row row-stats"
}
const _hoisted_12 = { class: "stat-val dim" }
const _hoisted_13 = { class: "card-row row-bottom" }
const _hoisted_14 = ["onClick"]
const _hoisted_15 = ["onClick"]
const _hoisted_16 = {
  key: 0,
  class: "empty-tip"
}
const _hoisted_17 = { class: "pagination-bar" }

import { NButton, NInput, NPagination } from 'naive-ui';
import { useRouter } from 'vue-router';
import { inject, ref, type Ref } from 'vue';
import Tools from '@/ts/Tools';


export default /*@__PURE__*/_defineComponent({
  __name: 'AccountList',
  props: {
    userList: {},
    totalCount: {},
    totalPages: {},
    currentPage: {},
    searchKeyword: {},
    sortBy: {},
    refreshingUser: {},
    refreshingAll: { type: Boolean }
  },
  emits: ["update:searchKeyword", "update:currentPage", "update:sortBy", "search", "pageChange", "refreshUser", "refreshAll", "modifyBalance", "toggleNoClear"],
  setup(__props: any, { emit: __emit }) {

const router = useRouter();
const debugMode = inject<Ref<boolean>>('debugMode', ref(false));



const emit = __emit;

function goDetail(userName: string) {
  router.push({ name: 'accountDetail', params: { userName } });
}

function netWinColor(val: number | undefined | null): string {
  if (val == null || val === 0) return 'zero';
  return val > 0 ? 'positive' : 'negative';
}

function cardTint(val: number | undefined | null): string {
  if (val == null || val === 0) return '';
  return val > 0 ? 'card-positive' : 'card-negative';
}

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createElementVNode("div", _hoisted_3, [
        _cache[7] || (_cache[7] = _createElementVNode("span", { class: "title" }, "📺 主播列表", -1)),
        _createElementVNode("span", _hoisted_4, _toDisplayString(_ctx.totalCount) + "位主播", 1)
      ]),
      _createElementVNode("div", _hoisted_5, [
        _createVNode(_unref(NInput), {
          value: _ctx.searchKeyword,
          "onUpdate:value": _cache[0] || (_cache[0] = ($event: any) => (emit('update:searchKeyword', $event))),
          onKeyup: _cache[1] || (_cache[1] = _withKeys(($event: any) => (emit('search')), ["enter"])),
          placeholder: "搜索主播...",
          size: "small",
          clearable: "",
          class: "search-input"
        }, null, 8, ["value"]),
        _createVNode(_unref(NButton), {
          size: "small",
          type: "primary",
          onClick: _cache[2] || (_cache[2] = ($event: any) => (emit('search'))),
          class: "search-btn"
        }, {
          default: _withCtx(() => _cache[8] || (_cache[8] = [
            _createTextVNode("搜索")
          ])),
          _: 1
        }),
        _createElementVNode("div", _hoisted_6, [
          _createVNode(_unref(NButton), {
            size: "tiny",
            type: _ctx.sortBy === 'credit' ? 'primary' : 'default',
            onClick: _cache[3] || (_cache[3] = ($event: any) => (emit('update:sortBy', 'credit'))),
            ghost: ""
          }, {
            default: _withCtx(() => _cache[9] || (_cache[9] = [
              _createTextVNode("💰 收益")
            ])),
            _: 1
          }, 8, ["type"]),
          _createVNode(_unref(NButton), {
            size: "tiny",
            type: _ctx.sortBy === 'id' ? 'primary' : 'default',
            onClick: _cache[4] || (_cache[4] = ($event: any) => (emit('update:sortBy', 'id'))),
            ghost: ""
          }, {
            default: _withCtx(() => _cache[10] || (_cache[10] = [
              _createTextVNode("📅 入驻")
            ])),
            _: 1
          }, 8, ["type"])
        ])
      ])
    ]),
    _createElementVNode("div", _hoisted_7, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.userList, (v) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["user-card", cardTint(v.totalWinAmount)]),
          key: v.userName
        }, [
          _createElementVNode("div", _hoisted_8, [
            _createElementVNode("span", {
              class: _normalizeClass(["live-dot", v.betCount > 0 ? 'online' : 'offline'])
            }, null, 2),
            _createElementVNode("span", {
              class: "user-name",
              onClick: _withModifiers(($event: any) => (goDetail(v.userName)), ["stop"])
            }, _toDisplayString(v.userName), 9, _hoisted_9),
            (v.nickname)
              ? (_openBlock(), _createElementBlock("span", _hoisted_10, _toDisplayString(v.nickname), 1))
              : _createCommentVNode("", true),
            _createElementVNode("span", {
              class: _normalizeClass(["status-tag", v.betCount > 0 ? 'live' : 'rest'])
            }, _toDisplayString(v.betCount > 0 ? '直播中' : '休息中'), 3)
          ]),
          (_unref(debugMode))
            ? (_openBlock(), _createElementBlock("div", _hoisted_11, [
                _createElementVNode("span", {
                  class: _normalizeClass(["stat-val", netWinColor(v.totalWinAmount)])
                }, _toDisplayString(_unref(Tools).formatMoney(v.totalWinAmount, { showSign: true })), 3),
                _createElementVNode("span", _hoisted_12, _toDisplayString((v.betCount ?? 0).toLocaleString()) + " 场", 1)
              ]))
            : _createCommentVNode("", true),
          _createElementVNode("div", _hoisted_13, [
            _createElementVNode("span", {
              class: _normalizeClass(["money", { pulse: _ctx.refreshingUser === v.userName }])
            }, [
              _cache[11] || (_cache[11] = _createElementVNode("i", null, "💰", -1)),
              _createTextVNode(_toDisplayString(_unref(Tools).formatMoney(v.credit)), 1)
            ], 2),
            _createElementVNode("span", {
              class: _normalizeClass(["card-refresh", { spinning: _ctx.refreshingUser === v.userName }]),
              onClick: _withModifiers(($event: any) => (emit('refreshUser', v)), ["stop"]),
              title: "刷新收益"
            }, "⟳", 10, _hoisted_14),
            _cache[13] || (_cache[13] = _createElementVNode("span", { class: "spacer" }, null, -1)),
            (_unref(debugMode))
              ? (_openBlock(), _createElementBlock("span", {
                  key: 0,
                  class: _normalizeClass(["protect-badge", { active: v.noClear }]),
                  onClick: _withModifiers(($event: any) => (emit('toggleNoClear', v)), ["stop"]),
                  title: "保护：勾选后不受数据清理影响"
                }, _toDisplayString(v.noClear ? '🔒' : '🔓'), 11, _hoisted_15))
              : _createCommentVNode("", true),
            _createVNode(_unref(NButton), {
              size: "small",
              type: "primary",
              ghost: "",
              onClick: _withModifiers(($event: any) => (emit('modifyBalance', v)), ["stop"])
            }, {
              default: _withCtx(() => _cache[12] || (_cache[12] = [
                _createTextVNode("调整")
              ])),
              _: 2
            }, 1032, ["onClick"])
          ])
        ], 2))
      }), 128)),
      (_ctx.userList.length === 0)
        ? (_openBlock(), _createElementBlock("div", _hoisted_16, _cache[14] || (_cache[14] = [
            _createElementVNode("span", { class: "empty-icon" }, "📭", -1),
            _createElementVNode("span", null, "暂无主播数据", -1)
          ])))
        : _createCommentVNode("", true)
    ]),
    _createElementVNode("div", _hoisted_17, [
      _createVNode(_unref(NPagination), {
        page: _ctx.currentPage,
        "onUpdate:page": _cache[5] || (_cache[5] = ($event: any) => {emit('update:currentPage', $event); emit('pageChange', $event)}),
        "page-count": _ctx.totalPages,
        "page-slot": 7,
        size: "small"
      }, null, 8, ["page", "page-count"])
    ]),
    _createElementVNode("span", {
      class: _normalizeClass(["global-refresh", { spinning: _ctx.refreshingAll }]),
      onClick: _cache[6] || (_cache[6] = ($event: any) => (emit('refreshAll'))),
      title: "刷新全部主播收益"
    }, "⟳", 2)
  ]))
}
}

})